
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Integrate Plaid with Straddle to deliver secure, identity-linked bank payments that settle quickly and feel as simple and reliable as using a debit card."
};
export const partnerProps = {
  partner: 'Straddle',
  clientLibrary: 'straddle',
  subtitle: metadata.description,
  registrationUrl: 'https://accounts.straddle.io/sign-up',
  apiUrl: 'https://docs.straddle.io/',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Straddle have partnered to deliver a streamlined bank payment experience that prioritizes security, speed, and developer-friendly integration. When customers connect their accounts through Plaid Link, Straddle automatically confirms account ownership via Plaid's Auth and Identity products, ensuring the account legitimately belongs to the intended user.`}</p>
    <p>{`Once ownership is verified, Straddle's Pay by Bank platform processes payments with built-in balance checks and continuous transaction monitoring. This means before any payment is initiated, Straddle confirms sufficient funds are available using Plaid's Balance product, reducing the risk of failed transactions. Throughout this process, sensitive banking data never directly touches your servers.`}</p>
    <p>{`By combining Plaid's industry leading account authentication with Straddle's robust payment infrastructure, businesses benefit from faster funding, fewer payment failures, and a more efficient onboarding flow. Whether you're processing recurring subscriptions, large B2B transfers, or specialized industry payments, you can handle bank payments reliably at scale—without ever holding sensitive banking details.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthIdentityInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
